import { Chip, ChipProps } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type InventoryChipProps = {
  outOfStock: boolean;
  outOfStockToday: boolean;
} & ChipProps;

enum InventoryType {
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  OUT_OF_STOCK_TODAY = 'OUT_OF_STOCK_TODAY',
  IN_STOCK = 'IN_STOCK',
}

const InventoryChip = ({
  outOfStock,
  outOfStockToday,
  ...rest
}: InventoryChipProps) => {
  const { t } = useTranslation();

  const inventoryType: InventoryType = useMemo(() => {
    if (outOfStock) {
      if (outOfStockToday) {
        return InventoryType.OUT_OF_STOCK_TODAY;
      }
      return InventoryType.OUT_OF_STOCK;
    }
    return InventoryType.IN_STOCK;
  }, [outOfStock, outOfStockToday]);

  switch (inventoryType) {
    case InventoryType.OUT_OF_STOCK:
      return (
        <Chip
          label={t('ItemsDataGrid.filter.inventory.outOfStock')}
          color="warning"
          size="small"
          {...rest}
        />
      );
    case InventoryType.OUT_OF_STOCK_TODAY:
      return (
        <Chip
          label={t('ItemsDataGrid.filter.inventory.outOfStockToday')}
          color="error"
          size="small"
          {...rest}
        />
      );
    case InventoryType.IN_STOCK:
      return (
        <Chip
          label={t('ItemsDataGrid.filter.inventory.inStock')}
          color="success"
          size="small"
          {...rest}
        />
      );
  }
};

export default InventoryChip;
